<template>
    <div v-if="isVisible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" style="z-index: 9999" @click.self="cancel">
        <div class="bg-white rounded-lg max-w-lg w-full max-h-[85vh] flex flex-col shadow-lg">
            <div class="overflow-y-auto flex-1 p-6">
                <h3 class="text-lg text-neutral font-medium text-center mb-4">
                    {{ $t("amlCheckWindow.title") }}
                </h3>

                <p class="text-sm text-neutral-content mb-4">
                    {{ $t("amlCheckWindow.body") }}
                </p>

                <div class="flex justify-center mb-4">
                    <MyButton variant="primary" classes="uppercase" :value="$t('amlCheckWindow.checkBtn')" @click.native="openReport" />
                </div>

                <p class="text-sm text-neutral-content mb-2">
                    {{ $t("amlCheckWindow.highRisk") }}
                </p>
                <p class="text-sm text-neutral mb-4 break-all">
                    {{ $t("amlCheckWindow.exampleLink") }}
                </p>

                <p class="text-sm text-neutral-content mb-3">
                    {{ $t("amlCheckWindow.riskAccept") }}
                </p>
                <p class="text-sm text-neutral-content mb-4">
                    {{ $t("amlCheckWindow.riskNotice") }}
                </p>

                <p class="text-sm text-center">
                    <span role="link" tabindex="0" class="text-primary hover:underline underline-offset-2 cursor-pointer" @click.stop="openAgreement" @keydown.enter.prevent="openAgreement" @keydown.space.prevent="openAgreement">
                        {{ $t("amlCheckWindow.amlPolicyLink") }}
                    </span>
                </p>
            </div>

            <div class="shrink-0 p-6 pt-4 border-t border-base-200 flex justify-center gap-2">
                <MyButton variant="primary" classes="mx-1" :value="$t('amlCheckWindow.continueBtn')" @click.native="confirm" />
                <MyButton variant="error" classes="mx-1" :value="$t('amlCheckWindow.cancelBtn')" @click.native="cancel" />
            </div>
        </div>
    </div>
</template>

<script>
import MyButton from "../ui/button.vue";
import CONSTANT_LINKS from "../../constants/links.json";

export default {
    name: "AmlCheckWindow",
    components: {
        MyButton
    },
    data() {
        return {
            isVisible: false,
            resolvePromise: null,
            rejectPromise: null
        };
    },
    computed: {
        reportUrl() {
            const locale = this.$i18n.locale === "ru" ? "rus" : "eng";
            return CONSTANT_LINKS.bestchangeAmlReport[locale];
        }
    },
    methods: {
        show() {
            this.isVisible = true;

            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
                this.rejectPromise = reject;
            });
        },
        openReport() {
            window.open(this.reportUrl, "_blank", "noopener,noreferrer");
        },
        openAgreement() {
            const path = this.$router.resolve({ path: "/aml-kyc" }).href;
            const url = path.startsWith("http") ? path : `${window.location.origin}${path}`;
            window.open(url, "_blank", "noopener,noreferrer");
        },
        confirm() {
            this.isVisible = false;
            this.$emit("confirm");
            if (this.resolvePromise) {
                this.resolvePromise();
            }
            this.resolvePromise = null;
            this.rejectPromise = null;
        },
        cancel() {
            this.isVisible = false;
            this.$emit("cancel");
            if (this.rejectPromise) {
                this.rejectPromise(new Error("Cancelled by user"));
            }
            this.resolvePromise = null;
            this.rejectPromise = null;
        }
    }
};
</script>
